const c = function() {
  let n = 0;
  const e = (/* @__PURE__ */ new Date()).getTime();
  return function(t) {
    const o = (/* @__PURE__ */ new Date()).getTime() - e, u = Math.floor(Math.random() * 1e3);
    t = t !== void 0 ? String(t) : "";
    const a = (t && "-") + n + "-" + o + "-" + u;
    return n += 1, t + a;
  };
}();
export {
  c as u
};
